<template>
  <div class="time-series-graph-loader">
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      preserveAspectRatio="xMidYMid meet"
      viewBox="111.73030062453554 63.94609929078007 447.8226950354632 221.97007515613478"
      width="750"
      height="350"
      class="loader"
    >
      <defs>
        <path
          d="M265.27 64.95L321.27 64.95L321.27 73.45L265.27 73.45L265.27 64.95Z"
          id="bwf5jvTw0"
        />
        <path
          d="M367.77 64.95L423.77 64.95L423.77 73.45L367.77 73.45L367.77 64.95Z"
          id="d2WiunIjb"
        />
        <path
          d="M559.55 285.92L547.48 162.42L526.56 266.92L524.95 177.42L512.88 268.92L495.98 188.92L492.76 260.92L483.91 122.92L473.45 268.42L469.43 146.92L450.12 263.92L443.68 155.42L431.61 256.92L421.95 190.92L412.3 266.92L399.42 111.42L386.55 272.92L370.45 245.92L361.6 266.42L351.94 243.92L343.09 261.92L327 179.42L317.34 261.92L307.69 141.42L292.4 271.92L265.04 159.92L258.6 261.42L236.07 151.42L230.44 225.92L213.54 144.42L205.49 273.42L180.55 187.42L167.67 280.42L165.26 158.92L155.6 224.42L153.99 121.92L139.51 263.92L133.07 163.92L123.41 274.92L115.37 203.42L112.15 284.42L559.55 285.92Z"
          id="b1QuT2UFOV"
        />
        <path
          d="M119.27 200.75C119.27 202.41 117.58 203.75 115.5 203.75C113.42 203.75 111.73 202.41 111.73 200.75C111.73 199.09 113.42 197.75 115.5 197.75C117.58 197.75 119.27 199.09 119.27 200.75Z"
          id="a35DhHQ2CQ"
        />
        <path
          d="M136.87 162.75C136.87 164.41 135.18 165.75 133.1 165.75C131.01 165.75 129.32 164.41 129.32 162.75C129.32 161.09 131.01 159.75 133.1 159.75C135.18 159.75 136.87 161.09 136.87 162.75Z"
          id="b3mgvDOKFs"
        />
        <path
          d="M157.81 119.75C157.81 121.41 156.12 122.75 154.04 122.75C151.96 122.75 150.27 121.41 150.27 119.75C150.27 118.09 151.96 116.75 154.04 116.75C156.12 116.75 157.81 118.09 157.81 119.75Z"
          id="g2KwcgpG8a"
        />
        <path
          d="M169.54 157.75C169.54 159.41 167.85 160.75 165.77 160.75C163.69 160.75 162 159.41 162 157.75C162 156.09 163.69 154.75 165.77 154.75C167.85 154.75 169.54 156.09 169.54 157.75Z"
          id="b3Je9DsGu"
        />
        <path
          d="M184.2 185.08C184.2 186.74 182.51 188.08 180.43 188.08C178.35 188.08 176.66 186.74 176.66 185.08C176.66 183.43 178.35 182.08 180.43 182.08C182.51 182.08 184.2 183.43 184.2 185.08Z"
          id="a20KNuUS2l"
        />
        <path
          d="M217.3 142.42C217.3 144.07 215.61 145.42 213.53 145.42C211.45 145.42 209.76 144.07 209.76 142.42C209.76 140.76 211.45 139.42 213.53 139.42C215.61 139.42 217.3 140.76 217.3 142.42Z"
          id="a4i0mUcmiz"
        />
        <path
          d="M239.92 149.08C239.92 150.74 238.23 152.08 236.15 152.08C234.07 152.08 232.38 150.74 232.38 149.08C232.38 147.43 234.07 146.08 236.15 146.08C238.23 146.08 239.92 147.43 239.92 149.08Z"
          id="a2tLi9UWsA"
        />
        <path
          d="M268.82 158.42C268.82 160.07 267.13 161.42 265.05 161.42C262.97 161.42 261.28 160.07 261.28 158.42C261.28 156.76 262.97 155.42 265.05 155.42C267.13 155.42 268.82 156.76 268.82 158.42Z"
          id="bOywNEdbv"
        />
        <path
          d="M311.55 139.75C311.55 141.41 309.86 142.75 307.78 142.75C305.7 142.75 304.01 141.41 304.01 139.75C304.01 138.09 305.7 136.75 307.78 136.75C309.86 136.75 311.55 138.09 311.55 139.75Z"
          id="a4aKP6nqyA"
        />
        <path
          d="M331.24 178.08C331.24 179.74 329.55 181.08 327.47 181.08C325.39 181.08 323.7 179.74 323.7 178.08C323.7 176.43 325.39 175.08 327.47 175.08C329.55 175.08 331.24 176.43 331.24 178.08Z"
          id="b15XTIKYxC"
        />
        <path
          d="M355.96 241.08C355.96 242.74 354.27 244.08 352.19 244.08C350.11 244.08 348.42 242.74 348.42 241.08C348.42 239.43 350.11 238.08 352.19 238.08C354.27 238.08 355.96 239.43 355.96 241.08Z"
          id="b2gWFYzOjw"
        />
        <path
          d="M373.97 242.08C373.97 243.74 372.28 245.08 370.2 245.08C368.12 245.08 366.43 243.74 366.43 242.08C366.43 240.43 368.12 239.08 370.2 239.08C372.28 239.08 373.97 240.43 373.97 242.08Z"
          id="b1CKowQP95"
        />
        <path
          d="M403.3 109.42C403.3 111.07 401.61 112.42 399.53 112.42C397.45 112.42 395.76 111.07 395.76 109.42C395.76 107.76 397.45 106.42 399.53 106.42C401.61 106.42 403.3 107.76 403.3 109.42Z"
          id="b1EUhezF3z"
        />
        <path
          d="M425.92 188.08C425.92 189.74 424.23 191.08 422.15 191.08C420.07 191.08 418.38 189.74 418.38 188.08C418.38 186.43 420.07 185.08 422.15 185.08C424.23 185.08 425.92 186.43 425.92 188.08Z"
          id="d6tgTwOmy"
        />
        <path
          d="M447.7 154.75C447.7 156.41 446.01 157.75 443.93 157.75C441.85 157.75 440.16 156.41 440.16 154.75C440.16 153.09 441.85 151.75 443.93 151.75C446.01 151.75 447.7 153.09 447.7 154.75Z"
          id="b1a6Nib1L7"
        />
        <path
          d="M472.84 145.08C472.84 146.74 471.15 148.08 469.07 148.08C466.99 148.08 465.3 146.74 465.3 145.08C465.3 143.43 466.99 142.08 469.07 142.08C471.15 142.08 472.84 143.43 472.84 145.08Z"
          id="eceDevC05"
        />
        <path
          d="M487.92 122.42C487.92 124.07 486.23 125.42 484.15 125.42C482.07 125.42 480.38 124.07 480.38 122.42C480.38 120.76 482.07 119.42 484.15 119.42C486.23 119.42 487.92 120.76 487.92 122.42Z"
          id="b5AlKbWHU"
        />
        <path
          d="M500.07 188.08C500.07 189.74 498.38 191.08 496.3 191.08C494.22 191.08 492.53 189.74 492.53 188.08C492.53 186.43 494.22 185.08 496.3 185.08C498.38 185.08 500.07 186.43 500.07 188.08Z"
          id="a3uUJc6BqP"
        />
        <path
          d="M528.55 175.75C528.55 177.41 526.86 178.75 524.78 178.75C522.7 178.75 521.01 177.41 521.01 175.75C521.01 174.09 522.7 172.75 524.78 172.75C526.86 172.75 528.55 174.09 528.55 175.75Z"
          id="b7gyGI5oh1"
        />
        <path
          d="M551.17 160.08C551.17 161.74 549.49 163.08 547.4 163.08C545.32 163.08 543.63 161.74 543.63 160.08C543.63 158.43 545.32 157.08 547.4 157.08C549.49 157.08 551.17 158.43 551.17 160.08Z"
          id="c13sj1Pqnr"
        />
      </defs>
      <g>
        <g>
          <use xlink:href="#bwf5jvTw0" opacity="1" fill="#f3f3f3" fill-opacity="1" />
          <g>
            <use
              xlink:href="#bwf5jvTw0"
              opacity="1"
              fill-opacity="0"
              stroke="#ededed"
              stroke-width="1"
              stroke-opacity="1"
            />
          </g>
        </g>
        <g>
          <use xlink:href="#d2WiunIjb" opacity="1" fill="#f3f3f3" fill-opacity="1" />
          <g>
            <use
              xlink:href="#d2WiunIjb"
              opacity="1"
              fill-opacity="0"
              stroke="#ededed"
              stroke-width="1"
              stroke-opacity="1"
            />
          </g>
        </g>
        <g>
          <g>
            <use xlink:href="#b1QuT2UFOV" opacity="1" fill="#f3f3f3" fill-opacity="1" />
            <g>
              <use
                xlink:href="#b1QuT2UFOV"
                opacity="1"
                fill-opacity="0"
                stroke="#e4e4e4"
                stroke-width="0.7"
                stroke-opacity="1"
              />
            </g>
          </g>
          <g>
            <use xlink:href="#a35DhHQ2CQ" opacity="1" fill="#f3f3f3" fill-opacity="1" />
            <g>
              <use
                xlink:href="#a35DhHQ2CQ"
                opacity="1"
                fill-opacity="0"
                stroke="#e4e4e4"
                stroke-width="0.7"
                stroke-opacity="1"
              />
            </g>
          </g>
          <g>
            <use xlink:href="#b3mgvDOKFs" opacity="1" fill="#f3f3f3" fill-opacity="1" />
            <g>
              <use
                xlink:href="#b3mgvDOKFs"
                opacity="1"
                fill-opacity="0"
                stroke="#e4e4e4"
                stroke-width="0.7"
                stroke-opacity="1"
              />
            </g>
          </g>
          <g>
            <use xlink:href="#g2KwcgpG8a" opacity="1" fill="#f3f3f3" fill-opacity="1" />
            <g>
              <use
                xlink:href="#g2KwcgpG8a"
                opacity="1"
                fill-opacity="0"
                stroke="#e4e4e4"
                stroke-width="0.7"
                stroke-opacity="1"
              />
            </g>
          </g>
          <g>
            <use xlink:href="#b3Je9DsGu" opacity="1" fill="#f3f3f3" fill-opacity="1" />
            <g>
              <use
                xlink:href="#b3Je9DsGu"
                opacity="1"
                fill-opacity="0"
                stroke="#e4e4e4"
                stroke-width="0.7"
                stroke-opacity="1"
              />
            </g>
          </g>
          <g>
            <use xlink:href="#a20KNuUS2l" opacity="1" fill="#f3f3f3" fill-opacity="1" />
            <g>
              <use
                xlink:href="#a20KNuUS2l"
                opacity="1"
                fill-opacity="0"
                stroke="#e4e4e4"
                stroke-width="0.7"
                stroke-opacity="1"
              />
            </g>
          </g>
          <g>
            <use xlink:href="#a4i0mUcmiz" opacity="1" fill="#f3f3f3" fill-opacity="1" />
            <g>
              <use
                xlink:href="#a4i0mUcmiz"
                opacity="1"
                fill-opacity="0"
                stroke="#e4e4e4"
                stroke-width="0.7"
                stroke-opacity="1"
              />
            </g>
          </g>
          <g>
            <use xlink:href="#a2tLi9UWsA" opacity="1" fill="#f3f3f3" fill-opacity="1" />
            <g>
              <use
                xlink:href="#a2tLi9UWsA"
                opacity="1"
                fill-opacity="0"
                stroke="#e4e4e4"
                stroke-width="0.7"
                stroke-opacity="1"
              />
            </g>
          </g>
          <g>
            <use xlink:href="#bOywNEdbv" opacity="1" fill="#f3f3f3" fill-opacity="1" />
            <g>
              <use
                xlink:href="#bOywNEdbv"
                opacity="1"
                fill-opacity="0"
                stroke="#e4e4e4"
                stroke-width="0.7"
                stroke-opacity="1"
              />
            </g>
          </g>
          <g>
            <use xlink:href="#a4aKP6nqyA" opacity="1" fill="#f3f3f3" fill-opacity="1" />
            <g>
              <use
                xlink:href="#a4aKP6nqyA"
                opacity="1"
                fill-opacity="0"
                stroke="#e4e4e4"
                stroke-width="0.7"
                stroke-opacity="1"
              />
            </g>
          </g>
          <g>
            <use xlink:href="#b15XTIKYxC" opacity="1" fill="#f3f3f3" fill-opacity="1" />
            <g>
              <use
                xlink:href="#b15XTIKYxC"
                opacity="1"
                fill-opacity="0"
                stroke="#e4e4e4"
                stroke-width="0.7"
                stroke-opacity="1"
              />
            </g>
          </g>
          <g>
            <use xlink:href="#b2gWFYzOjw" opacity="1" fill="#f3f3f3" fill-opacity="1" />
            <g>
              <use
                xlink:href="#b2gWFYzOjw"
                opacity="1"
                fill-opacity="0"
                stroke="#e4e4e4"
                stroke-width="0.7"
                stroke-opacity="1"
              />
            </g>
          </g>
          <g>
            <use xlink:href="#b1CKowQP95" opacity="1" fill="#f3f3f3" fill-opacity="1" />
            <g>
              <use
                xlink:href="#b1CKowQP95"
                opacity="1"
                fill-opacity="0"
                stroke="#e4e4e4"
                stroke-width="0.7"
                stroke-opacity="1"
              />
            </g>
          </g>
          <g>
            <use xlink:href="#b1EUhezF3z" opacity="1" fill="#f3f3f3" fill-opacity="1" />
            <g>
              <use
                xlink:href="#b1EUhezF3z"
                opacity="1"
                fill-opacity="0"
                stroke="#e4e4e4"
                stroke-width="0.7"
                stroke-opacity="1"
              />
            </g>
          </g>
          <g>
            <use xlink:href="#d6tgTwOmy" opacity="1" fill="#f3f3f3" fill-opacity="1" />
            <g>
              <use
                xlink:href="#d6tgTwOmy"
                opacity="1"
                fill-opacity="0"
                stroke="#e4e4e4"
                stroke-width="0.7"
                stroke-opacity="1"
              />
            </g>
          </g>
          <g>
            <use xlink:href="#b1a6Nib1L7" opacity="1" fill="#f3f3f3" fill-opacity="1" />
            <g>
              <use
                xlink:href="#b1a6Nib1L7"
                opacity="1"
                fill-opacity="0"
                stroke="#e4e4e4"
                stroke-width="0.7"
                stroke-opacity="1"
              />
            </g>
          </g>
          <g>
            <use xlink:href="#eceDevC05" opacity="1" fill="#f3f3f3" fill-opacity="1" />
            <g>
              <use
                xlink:href="#eceDevC05"
                opacity="1"
                fill-opacity="0"
                stroke="#e4e4e4"
                stroke-width="0.7"
                stroke-opacity="1"
              />
            </g>
          </g>
          <g>
            <use xlink:href="#b5AlKbWHU" opacity="1" fill="#f3f3f3" fill-opacity="1" />
            <g>
              <use
                xlink:href="#b5AlKbWHU"
                opacity="1"
                fill-opacity="0"
                stroke="#e4e4e4"
                stroke-width="0.7"
                stroke-opacity="1"
              />
            </g>
          </g>
          <g>
            <use xlink:href="#a3uUJc6BqP" opacity="1" fill="#f3f3f3" fill-opacity="1" />
            <g>
              <use
                xlink:href="#a3uUJc6BqP"
                opacity="1"
                fill-opacity="0"
                stroke="#e4e4e4"
                stroke-width="0.7"
                stroke-opacity="1"
              />
            </g>
          </g>
          <g>
            <use xlink:href="#b7gyGI5oh1" opacity="1" fill="#f3f3f3" fill-opacity="1" />
            <g>
              <use
                xlink:href="#b7gyGI5oh1"
                opacity="1"
                fill-opacity="0"
                stroke="#e4e4e4"
                stroke-width="0.7"
                stroke-opacity="1"
              />
            </g>
          </g>
          <g>
            <use xlink:href="#c13sj1Pqnr" opacity="1" fill="#f3f3f3" fill-opacity="1" />
            <g>
              <use
                xlink:href="#c13sj1Pqnr"
                opacity="1"
                fill-opacity="0"
                stroke="#e4e4e4"
                stroke-width="0.7"
                stroke-opacity="1"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  </div>
</template>
<script>
export default {
  name: 'TimeSeriesGraphLoader',
  props: {
    size: {
      type: Array,
      default: () => [780, 400],
    },
  },
};
</script>
<style lang="scss" scoped>
@keyframes hideshow {
  0% {
    opacity: 1;
  }
  10% {
    opacity: 0.8;
  }
  15% {
    opacity: 0.6;
  }
  100% {
    color: #ecebeb;
    opacity: 0.4;
  }
}
.time-series-graph-loader {
  .loader {
    margin-top: 50px;
    animation: hideshow 1.5s ease-in-out infinite;
  }
}
</style>


// WEBPACK FOOTER //
// TimeSeriesGraphLoader.vue?488ad87e